module.exports = __webpack_public_path__ + "img/asii-logo.53a3a67a.jpg";